import React from "react";
import { MapPin, Nfc, QrCode } from "lucide-react";
import { placeName } from "./TraceMap";

function fmt(iso) {
  const d = new Date(iso);
  return {
    date: d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" }),
    time: d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" }),
  };
}

export default function TraceTimeline({ events, showIp = false }) {
  const ordered = [...events].reverse();
  return (
    <ol className="relative" data-testid="trace-timeline">
      {ordered.map((e, i) => {
        const { date, time } = fmt(e.timestamp);
        const Icon = e.source === "qr" ? QrCode : Nfc;
        return (
          <li
            key={e.id}
            className="trace-item flex items-start gap-4 py-4 border-b"
            style={{ borderColor: "var(--vault-border)", animationDelay: `${Math.min(i, 8) * 60}ms` }}
            data-testid={`trace-event-${e.id}`}
          >
            <span className="mt-0.5 w-8 h-8 shrink-0 rounded-full flex items-center justify-center" style={{ background: "rgba(197,160,89,0.12)", border: "1px solid rgba(197,160,89,0.3)" }}>
              <MapPin className="w-3.5 h-3.5" style={{ color: "var(--vault-gold)" }} />
            </span>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-white truncate" data-testid="trace-event-place">{placeName(e)}</p>
              {(e.flagged || e.new_country) && (
                <div className="flex flex-wrap gap-1.5 mt-1">
                  {e.flagged && <span className="text-[10px] px-2 py-0.5 rounded-full" style={{ background: "rgba(153,27,27,0.2)", color: "#FCA5A5" }} data-testid="trace-flag-outside">Outside allowed countries</span>}
                  {e.new_country && <span className="text-[10px] px-2 py-0.5 rounded-full" style={{ background: "rgba(197,160,89,0.15)", color: "var(--vault-gold)" }} data-testid="trace-flag-new-country">New country</span>}
                </div>
              )}
              <p className="text-xs text-[var(--vault-text-muted)] mt-0.5 font-mono-vault">
                {date} · {time}
                {showIp && e.ip ? <span className="ml-2 text-[var(--vault-text-faint)]">{e.ip}</span> : null}
              </p>
            </div>
            <span className="overline inline-flex items-center gap-1.5 text-[var(--vault-text-muted)] shrink-0" data-testid="trace-event-source">
              <Icon className="w-3.5 h-3.5" /> {e.source === "qr" ? "QR" : "NFC"}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
